// src/pages/ContactPage.js
import React, { useState } from 'react';
import { useApp } from '../lib/AppContext';

export default function ContactPage() {
  const { showToast } = useApp();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      showToast('Please fill in all fields', 'error');
      return;
    }
    // Opens default mail client with pre-filled body as a simple fallback.
    // Replace with a real form endpoint (e.g. Netlify Forms, Formspree, Supabase Edge Function).
    const subject = encodeURIComponent(`Contact from ${form.name}`);
    const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:info@cosmiqherbz.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="simple-page">
      <span className="page-eyebrow">Get in touch</span>
      <h1>Contact Us</h1>
      <p className="page-intro">
        Have a question about an order, a product, or anything else?
        We're happy to help — fill in the form below or email us directly.
      </p>

      {/* Direct contact info */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 16,
        marginBottom: 40,
      }}>
        {[
          { icon: '✉️', label: 'Email', value: 'info@cosmiqherbz.com', href: 'mailto:info@cosmiqherbz.com' },
          { icon: '🕐', label: 'Response time', value: 'Within 24 hours', href: null },
          { icon: '🌍', label: 'We ship to', value: 'All EU countries', href: null },
        ].map(item => (
          <div key={item.label} style={{
            background: '#111',
            border: '1px solid rgba(255,255,255,.07)',
            borderRadius: 14,
            padding: '20px',
          }}>
            <div style={{ fontSize: '1.4rem', marginBottom: 8 }}>{item.icon}</div>
            <div style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: '.68rem', fontWeight: 700,
              letterSpacing: '.18em', textTransform: 'uppercase',
              color: '#4cca74', marginBottom: 4,
            }}>
              {item.label}
            </div>
            {item.href
              ? <a href={item.href} style={{ color: '#f4f4f4', fontSize: '.88rem', textDecoration: 'none' }}>{item.value}</a>
              : <span style={{ color: '#888', fontSize: '.88rem' }}>{item.value}</span>
            }
          </div>
        ))}
      </div>

      {/* Contact form */}
      {sent ? (
        <div style={{
          background: 'rgba(76,202,116,.08)',
          border: '1px solid rgba(76,202,116,.2)',
          borderRadius: 16, padding: 32, textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>✅</div>
          <div style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: '1.6rem', letterSpacing: '.04em',
            color: '#4cca74', marginBottom: 8,
          }}>
            Message Sent
          </div>
          <p style={{ color: '#666', fontSize: '.88rem' }}>
            Your email client should have opened. If not, email us directly at{' '}
            <a href="mailto:info@cosmiqherbz.com" style={{ color: '#4cca74' }}>
              info@cosmiqherbz.com
            </a>
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <div>
            <div className="input-label">Your Name *</div>
            <input
              className="input-field"
              type="text"
              value={form.name}
              onChange={e => update('name', e.target.value)}
              placeholder="Jane Smith"
              autoComplete="name"
            />
          </div>
          <div>
            <div className="input-label">Email Address *</div>
            <input
              className="input-field"
              type="email"
              value={form.email}
              onChange={e => update('email', e.target.value)}
              placeholder="jane@example.com"
              autoComplete="email"
            />
          </div>
          <div>
            <div className="input-label">Message *</div>
            <textarea
              className="input-field"
              rows={6}
              value={form.message}
              onChange={e => update('message', e.target.value)}
              placeholder="Tell us what you need..."
              style={{ resize: 'vertical', minHeight: 120 }}
            />
          </div>
          <button className="btn-primary" type="submit" style={{ alignSelf: 'flex-start', minWidth: 180 }}>
            Send Message
          </button>
        </form>
      )}
    </div>
  );
}
